import React from 'react';
import * as S from './GoSafeDetailedPersuasion.styles';

const GoSafeDetailedPersuasion: React.FC<{
  mainImage: string;
  style?: Object;
  message: string;
  colorCodes?: {
    bgc: string;
    tc: string;
  };
}> = ({mainImage, style = {}, message, colorCodes = {bgc: '', tc: ''}}) => {
  return (
    <S.GoSafeMainContainer style={style} backgroundColor={colorCodes?.bgc}>
      <S.GosafeImg src={mainImage} />
      {/* <S.TextContentBoldSpan>Audited by Deloitte </S.TextContentBoldSpan> */}
      <S.TextContentNormalSpan
        color={colorCodes?.tc}
        dangerouslySetInnerHTML={{
          __html: message,
        }}
      />
    </S.GoSafeMainContainer>
  );
};

export default GoSafeDetailedPersuasion;
